import { FunctionComponent } from 'react';

import { ArrowRightIcon } from '../Arrow/ArrowRight.icon';
import { IconPropsInterface } from '../Icon.types';

const ChevronRightIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <ArrowRightIcon size={size} color={color} {...rest} />;

ChevronRightIcon.displayName = 'ChevronRightIcon';

export default ChevronRightIcon;
